import _Field from "redux-form/es/Field";
import _FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import _Checkbox from "@material-ui/core/esm/Checkbox";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { HUBSPOT_FIELDS } from 'swag-common/constants/hubspot';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonType, ButtonTextTransform } from 'swag-client-common/components/ui/button/button';
import TextField from '../../ui/text-field';
import Select from '../../ui/select';
import classes from './request-demo-popup.scss';
import { formControlLabelClasses, companySizeOptions, checkboxClasses, popupClasses, checkboxes, inputs } from './request-demo-popup.constants';
const renderCheckbox = _ref => {
  let {
      input,
      label
    } = _ref,
    rest = _objectWithoutProperties(_ref, ["input", "label"]);
  return /*#__PURE__*/React.createElement(_FormControlLabel, {
    classes: formControlLabelClasses,
    control: /*#__PURE__*/React.createElement(_Checkbox, _extends({
      checked: input.value ? true : false,
      onChange: input.onChange,
      classes: checkboxClasses
    }, rest)),
    label: label
  });
};
const RequestDemoPopup = ({
  open,
  onClose,
  onSubmitRequest,
  pristine,
  valid
}) => {
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: onClose,
    classes: popupClasses,
    titleHeader: classes.title,
    contentClass: classes.popupContent,
    title: "Request a Demo!",
    showCloseButton: true
  }, inputs.map(({
    name,
    label,
    validation
  }) => /*#__PURE__*/React.createElement(_Field, {
    key: name,
    name: name,
    component: TextField,
    className: classes.input,
    type: "text",
    label: label,
    validate: validation
  })), /*#__PURE__*/React.createElement(_Field, {
    name: HUBSPOT_FIELDS.COMPANY_SIZE,
    component: Select,
    type: "text",
    label: "How many employees?",
    options: companySizeOptions,
    contain: true,
    fullWidth: true
  }), /*#__PURE__*/React.createElement("p", {
    className: classes.checkboxesLabel
  }, "What are you interested in? Check all that apply:"), /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxesContainer
  }, checkboxes.map(({
    name,
    label
  }) => /*#__PURE__*/React.createElement(_Field, {
    key: name,
    component: renderCheckbox,
    label: label,
    name: name,
    type: "checkbox",
    color: "primary"
  }))), /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    type: ButtonType.primary,
    textTransform: ButtonTextTransform.none,
    onClick: onSubmitRequest,
    disabled: pristine || !valid
  }, "Request a Demo"));
};
export default RequestDemoPopup;